<ngb-toast
    *ngFor="let toast of toastService.toasts"
    [class]="toast.class"
    [autohide]='true'
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)"
    >
    <div [innerHTML]="toast.text"></div>
</ngb-toast>
